export default "__VITE_ASSET__dc88dd62__"